import { useState, useEffect } from 'react';
import Sidebar from "../components/sidebar";
import AddEmployeePage from "../components/addstaff";
import EditEmployeePage from "../components/editemployee"; 
import Team from "../components/team";
import { fetchStaff, deleteStaff } from '../services/staffHandler';

interface Staff {
  id: string;
  name: string;
  role: string;
  description: string;
  certificates: string;
  experience: string;
  imageUrl: string;
}

const StaffManagement = () => {
  const [staffList, setStaffList] = useState<Staff[]>([]);
  const [showAddStaff, setShowAddStaff] = useState(false);
  const [editStaffData, setEditStaffData] = useState<Staff | null>(null);

  useEffect(() => {
    if (!showAddStaff) {
      const loadStaff = async () => {
        try {
          const fetchedStaff = await fetchStaff();
          setStaffList(fetchedStaff);
        } catch (error) {
          console.error("Error loading staff:", error);
        }
      };
  
      loadStaff();
    }
  }, [showAddStaff]);  
  

  const handleDelete = async (id: string) => {
    try {
      await deleteStaff(id);
      setStaffList(staffList.filter(staff => staff.id !== id));
    } catch (error) {
      console.error('Error deleting staff:', error);
    }
  };

  const handleEdit = (staff: Staff) => {
    setEditStaffData(staff);
  };

  return (
    <div>
      <Sidebar />
      {showAddStaff && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
          <div className="max-w-4xl w-3/4">
            <AddEmployeePage onClose={() => setShowAddStaff(false)} />
          </div>
        </div>
      )}
      {editStaffData && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
          <div className="max-w-4xl w-3/4">
            <EditEmployeePage staff={editStaffData} onClose={() => setEditStaffData(null)} />
          </div>
        </div>
      )}
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="sm:flex sm:items-center">
          <div className="sm:flex-auto">
            <h1 className="text-base font-semibold leading-6 text-gray-900">Staff Management</h1>
            <p className="mt-2 text-sm text-gray-700">Manage all the staff members.</p>
          </div>
          <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
            <button
              type="button"
              className="block rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              onClick={() => setShowAddStaff(true)}
            >
              Add a new staff member
            </button>
          </div>
        </div>
        <div className="mt-8 flow-root">
          <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
              <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-300">
                  <thead className="bg-gray-50">
                    <tr>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Name
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Role
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Description
                      </th>
                      <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                        <span className="sr-only">Actions</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {staffList.map((staff) => (
                      <tr key={staff.id}>
                        <td className="whitespace-normal break-words px-3 py-4 text-sm text-gray-500">{staff.name}</td>
                        <td className="whitespace-normal break-words px-3 py-4 text-sm text-gray-500">{staff.role}</td>
                        <td className="whitespace-normal break-words px-3 py-4 text-sm text-gray-500">{staff.description}</td>
                        <td className="py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                          <button
                            onClick={() => handleEdit(staff)}
                            className="text-indigo-600 hover:text-indigo-900"
                          >
                            Edit
                          </button>
                          <button
                            onClick={() => handleDelete(staff.id)}
                            className="text-red-600 hover:text-red-900 ml-4"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Team /> */}
    </div>
  );
};

export default StaffManagement;
